import * as THREE from "three"
import Home from "./Home"
import Experience from "../../../Experience"


import starsFragment from "../../../shaders/stars/starsFragment.glsl"
import starsVertex from "../../../shaders/stars/starsVertex.glsl"


export default class Stars {

    constructor() {

        this.home = new Home()
        this.scene = this.home.scene
        this.time = this.home.time
        this.spawn()

    }

    spawn() {
        this.pointsCount = 100
        this.positions = new Float32Array(this.pointsCount * 3)
        this.sizes = new Float32Array(this.pointsCount)

        this.pointsGeometry = new THREE.BufferGeometry()

        for (let i = 0; i < this.pointsCount; i++) {
            const i3 = i * 3
            this.positions[i3 + 0] = (Math.random() - 0.5) * 25
            this.positions[i3 + 1] = (Math.random() - 0.5) * 25
            this.positions[i3 + 2] = 0

            this.sizes[i] = Math.random()
        }

        this.positionAttribute = new THREE.BufferAttribute(this.positions, 3)
        this.sizesAttribute = new THREE.BufferAttribute(this.sizes, 1)
        this.pointsGeometry.setAttribute("position", this.positionAttribute)
        this.pointsGeometry.setAttribute("aSize", this.sizesAttribute)

        this.stars = new THREE.Points(
            this.pointsGeometry,
            new THREE.ShaderMaterial({
                vertexShader: starsVertex,
                fragmentShader: starsFragment,

                uniforms: {
                    uTime: { value: 0 }
                }
            })
        )
        this.stars.material.size = 5
        this.scene.add(this.stars)
    }


    update() {
        this.stars.material.uniforms.uTime.value = this.time.elapsedTime
    }
}